import apiService from "../services/api";
import formService from "../services/form";

const bookingMixin = {
  methods: {
    // gestione errori
    _error(err = "") {
      console.error("[booking] errore:", err);
      var messaggi = err ? (Array.isArray(err) ? err : [err]) : [];

      // con la camera solo bloccata da un altro pagamento in corso il form resta compilato,
      // quindi si può tornare al pagamento invece di ricominciare da capo.
      // la destinazione vale solo per questo errore: senza reset resterebbe quella del precedente
      var tornaAlPagamento = messaggi.includes("CameraInPagamentoError");
      this.$store.backbtn = tornaAlPagamento ? "IndietroPag" : "";
      this.$store.backpath = tornaAlPagamento ? "/form" : "";
      this.$store.resetform = false;

      messaggi.forEach((msg) => this.$store.err.push(msg));
      this.$router.push("/errore");
    },
    tariffa_label(camera) {
      if (camera.codice && camera.titolo) {
        var subtitle = camera.tariffa.tipo;
        subtitle += " [" + camera.tariffa.trattamento;
        if (camera.tariffa.sconto) {
          subtitle += "] " + this._sconto(camera.tariffa);
        } else {
          subtitle += "] " + camera.tariffa.prezzo;
        }
        return subtitle;
      }
      return "";
    },
    camera_label(camera) {
      var idx = camera.key + 1;
      if (camera.codice && camera.titolo) {
        return (
          formService._upper(this.labels.Room) +
          " " +
          idx +
          ": " +
          camera.titolo
        );
      }
      return formService._upper(this.labels.Room) + " " + idx;
    },
    camera_label_active(ospiti) {
      for (let index = 0; index < ospiti.length; index++) {
        var camera = ospiti[index];
        if (!camera.active) {
          continue;
        }
        var idx = camera.key + 1;
        if (camera.codice && camera.titolo) {
          return (
            formService._upper(this.labels.Room) +
            " " +
            idx +
            ": " +
            camera.titolo
          );
        }
        return formService._upper(this.labels.Room) + " " + idx;
      }
    },
    // calcolo prezzo minore
    _prenotabile(tariffa) {
      return tariffa && tariffa.disponibili > 0 && String(tariffa.tarattiva) === "1";
    },
    prezzo_min(tariffe) {
      var minimo = null;
      var etichetta = "";
      if (tariffe) {
        for (let index = 0; index < tariffe.length; index++) {
          if (!this._prenotabile(tariffe[index])) {
            continue;
          }
          var testo = this._sconto(tariffe[index]);
          var valore = formService.parsePrice(testo);
          if (!(valore > 0)) {
            continue;
          }
          if (minimo === null || valore < minimo) {
            minimo = valore;
            etichetta = testo;
          }
        }
      }
      return etichetta;
    },
    prezzo_totale(scontato = true) {
      var tot = 0;
      this.form.ospiti.map((el) => {
        if (el.tariffa && el.tariffa.prezzo) {
          tot += formService._toFloat(this.servizio_prezzo(el, scontato));
        }
      });
      return formService._toStr(tot);
    },
    servizio_prezzo(camera, scontato = true) {
      var srv = 0;
      camera.servizi.map((el) => {
        srv += formService._toFloat(el.prezzo);
      });
      return formService._toStr(
        formService._toFloat(
          scontato ? camera.tariffa.prezzo : camera.tariffa.prezzo_base
        ) + srv
      );
    },
    // chiamata backend per confermare la prenotazione
    finalize(content, redirect = false) {
      apiService
        .post(
          "BE_prenotazione/finalize/" +
            this.$store.db +
            "/" +
            this.$store.idhotel +
            "/" +
            this.$store.lang,
          { ...this.form, content: content }
        )
        .then((res) => {
          // tutto ok
          this.form.prenotata = true;
          this.form.lockid = res.lockid;
          this.$store.form = this.form;
          if (redirect) {
            this._goNext(redirect, this.form);
          }
        })
        .catch((err) => {
          console.error("[booking] finalize fallita:", err);
          var messaggi = err && err.msg && err.msg.length > 0 ? [...err.msg] : [];

          if (content && content.codtrans) {
            // pagamento online già incassato da Nexi ma prenotazione non salvata: va detto all'utente
            messaggi.unshift("ERR_PRENO_PAGATA");
          } else if (messaggi.length === 0) {
            messaggi.push("ERR_GENERIC");
          }
          this._error(messaggi);
        });
    },
    combo(resource, name = resource, param = "") {
      return new Promise((resolve) => {
        apiService
          .get("BE_booking/systab_be/" + resource + (param ? "/" + param : ""))
          .then((resp) => {
            if (resp[name] !== "undefined" && resp[name].length > 0) {
              resolve(resp[name]);
            }
            resolve([]);
          })
          .catch(() => {
            resolve([]);
          });
      });
    },
    // selettore icone servizi
    _icon(servizio = "") {
      switch (servizio.toLowerCase()) {
        case "wifi":
          return ["fas", "wifi"];
        case "vent":
          return ["fas", "fan"];
        case "tv":
          return ["fas", "tv"];
        default:
          return ["fas", "circle"];
      }
    },
    _sconto(obj) {
      if (obj.sconto) {
        var pieno = formService.parsePrice(obj.prezzo);
        return formService._toStr(pieno - pieno * (obj.sconto / 100));
      } else {
        return obj.prezzo;
      }
    },
    // formattazione label + spazio
    _label(label = "") {
      if (label.trim() !== "") {
        return " ";
      }
      return "";
    },
    _goNext(route, formdata = false) {
      if (formdata !== false) {
        this.$store.form = formdata;
      }
      this.$router.push(route);
    },
    _fill(obj, data) {
      for (const key in data) {
        obj[key] = data[key];
      }
    },
    reset() {
      this._goNext(
        "/?RPC_db=" +
          this.$store.db +
          "&idhotel=" +
          this.$store.idhotel +
          "&lan=" +
          this.$store.lang,
        null
      );
    }
  }
};

export default bookingMixin;
